module.exports = __webpack_public_path__ + "media/images/favicons/android-chrome-192x192-f4f123cd06dcd86bf82a69411fec487c.png";